import { z } from "zod";

export const raw16Schema = z.string().regex(/^[0-9a-f]{32}$/u);

const timestampSchema = z.string().datetime({ offset: true });

export const checkoutExceptionSchema = z.strictObject({
  exceptionId: raw16Schema,
  propertyId: raw16Schema,
  checkoutRunId: raw16Schema.nullable(),
  exceptionKind: z.string().regex(/^E(?:[1-9]|1[0-2])$/u),
  routedTo: z.enum(["OWNER", "ADMIN", "SYSTEM"]),
  status: z.enum(["OPEN", "RESOLVED", "ESCALATED"]),
  resolutionNote: z.string().nullable(),
  raisedAt: timestampSchema,
  resolvedAt: timestampSchema.nullable(),
});

export const checkoutExceptionListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  exceptions: z.array(checkoutExceptionSchema),
});

export const checkoutExceptionResolveResponseSchema = z.strictObject({
  status: z.enum(["resolved", "unchanged"]),
});

export type CheckoutException = z.infer<typeof checkoutExceptionSchema>;
